import * as React from 'react';

import {safelyGetFilterByKey} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

import {DateRangePickerSimple} from 'shells/date-range-picker/date-range-picker-simple';

import type {DateRangeType} from './report-types';

import styles from './report-date-range-picker.module.css';

type Props = {
    dateRangeType: DateRangeType;
    dateRangeOptions: {
        id: string;
        value: string;
    }[];
    activeFilters: FilterObject[];
    onDateRangeChange: (arg1: FilterObject) => any;
};

export class ReportDateRangePickerSimple extends React.PureComponent<Props> {
    render() {
        const dateRangeFilter = safelyGetFilterByKey(
            this.props.activeFilters,
            this.props.dateRangeType
        );

        return (
            <div className={styles['report-date-range-picker']}>
                <DateRangePickerSimple
                    filter={dateRangeFilter}
                    dateRangeOptions={this.props.dateRangeOptions}
                    onChange={this.handleDateRangeChange}
                />
            </div>
        );
    }

    /**
     * Helper function to look up a dynamic filter type based on the date
     * range leadBin being used. Creates a fitlerObj and calls props.onDateRangeChange
     * together with an optional comparison range type
     *
     * @param  {string} dateFilter       - New date range returned from our datePicker
     * @param  {string} [comparisonType] - Compare by previous period or previous year
     * @return {void}
     */
    handleDateRangeChange = (dateFilter: string) => {
        const newDateFilter = {[this.props.dateRangeType]: dateFilter} as const;
        this.props.onDateRangeChange(newDateFilter);
    };
}
